/**
 * Shadow this file!
 * If you shadow this file, the default theme will NOT be loaded
 **/

import _reduce from "lodash/reduce";
import { css } from "styled-components";

const black = "#000000";
const almostBlack = "#222222";
// const bodyBackgroundGrey = "#1A1A1A";
const offBlack = "#3f3f3f";
const grey = "#757575";
const hamburgerGrey = "#707070";
const mediumGrey = "#9B9B9B";
const mayAsWellBeWhite = "#f9f9f9";
const offWhite = "#fafaf9";
const barelyGrey = "#f2f2f2";
const lighterGrey = "#e8e8e8";
const lightGrey = "#dbd9d6";
// const subNavigationGrey = "#e7e5e3";
const white = "#ffffff";
const blueGrey = "#4e6b87";
const darkGrey = "#4d4d4d";
// const green = "#7ed321";
const red = "#f23d3d";
const pink = "#fed9db";
const yellow = "#FBC546";
const orange = "#ff5f00";
const brownGrey = "#696057";
const darkBrownGrey = "#382e2b";
const silver = "#a5a5a5";

const sizes = {
  xl: "75em",
  large: "60em",
  medium: "45em",
  small: "30em",
  default: "0px",
  mobile375: "375px",
  mobile480: "480px",
  tablet720: "720px",
  tablet768: "768px",
  tablet960: "960px",
  desktop1200: "1200px",
  desktop1920: "1920px",
};

// Accumulate each size into a media template helper function
const accumulateMediaTemplateFunction = (accumulator, value, key) => {
  // eslint-disable-next-line no-param-reassign
  accumulator[key] = (...args) => css`
    @media (min-width: ${value}${typeof value === "string" ? "" : "px"}) {
      ${css(...args)};
    }
  `;
  return accumulator;
};
const mediaTemplates = _reduce(sizes, accumulateMediaTemplateFunction, {});

const defaultTheme = {
  colors: {
    black,
    offBlack,
    almostBlack,
    // bodyBackgroundGrey,
    // bodyBackgroundGray: bodyBackgroundGrey,
    grey,
    gray: grey,
    hamburgerGrey,
    hamburgerGray: hamburgerGrey,
    lighterGrey,
    lighterGray: lighterGrey,
    lightGrey,
    lightGray: lightGrey,
    mediumGrey,
    mediumGray: mediumGrey,
    // subNavigationGrey,
    // subNavigationGray: subNavigationGrey,
    darkGrey,
    offWhite,
    barelyGrey,
    barelyGray: barelyGrey,
    mayAsWellBeWhite,
    white,
    blueGrey,
    brownGrey,
    darkBrownGrey,
    silver,
    // green,
    red,
    pink,
    yellow,
    orange,
  },
  schemes: {
    default: {
      light: white,
      dark: brownGrey,
      primary: orange,
      button: {
        bordered: {
          light: {
            color: white,
            hover: {
              color: orange,
            },
          },
          dark: {
            color: brownGrey,
            hover: {
              color: orange,
            },
          },
          primary: {
            color: orange,
            hover: {
              color: brownGrey,
            },
          },
        },
        filled: {
          light: {
            text: darkBrownGrey,
            background: lightGrey,
            hover: {
              text: white,
              background: brownGrey,
            },
          },
          dark: {
            text: white,
            background: brownGrey,
            hover: {
              text: white,
              background: orange,
            },
          },
          primary: {
            text: white,
            background: orange,
            hover: {
              text: white,
              background: brownGrey,
            },
          },
        },
        custom: {
          whiteBgYellowBorder: {
            text: brownGrey,
            border: yellow,
            background: white,
            borderWidth: "2px",
            hover: {
              text: brownGrey,
              border: yellow,
              background: yellow,
            },
          },
        },
      },
      input: {
        light: {
          background: "transparent",
          color: white,
          border: white,
          focus: {
            border: lightGrey,
          },
          active: {
            background: lightGrey,
            color: white,
            border: lightGrey,
          },
        },
        dark: {
          background: "transparent",
          color: brownGrey,
          border: brownGrey,
          focus: {
            border: brownGrey,
          },
          active: {
            background: brownGrey,
            color: white,
            border: brownGrey,
          },
        },
        default: {
          background: white,
          color: grey,
          border: lightGrey,
          focus: {
            border: blueGrey,
          },
          active: {
            background: lightGrey,
            color: white,
            border: lightGrey,
          },
        },
        blueGrey: {
          background: white,
          color: grey,
          border: lightGrey,
          focus: {
            border: blueGrey,
          },
          active: {
            border: blueGrey,
            background: blueGrey,
            color: white,
          },
        },
      },
    },
  },
  fontFamily: "gotham",
  sizes,
  ...mediaTemplates,
  maxWidth: "1440px",
};

export default defaultTheme;
